import styled, { css } from 'styled-components';
import { Disableable } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';
import { Component, Decision, getComponentToken, SPACING } from '@optimus-web/local-tokens';
import { getInputTextPresetCss, LeftDetailContainer } from '../commonStyle';
import { Icon } from '../Icon';
import { ELLIPSIS, getHorizontalInputPadding } from '../theme';
import { SizeType } from '../types';

export interface ComboInputElementProps {
    large?: boolean;
    disabled?: boolean;
}

export const ComboInputElement = styled.div<ComboInputElementProps>`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    width: 100%;
    outline: none;
`;

export const ClearIcon = styled(Icon).attrs({
    value: IconName.CrossClose,
})`
    align-self: center;
    cursor: pointer;
    outline: none;
`;

export const RightVariantContainer = styled.div`
    display: inline-flex;
    margin-right: ${SPACING[100]}px;
`;

export const LeftVariantContainer = styled(LeftDetailContainer)`
    padding: 0 0 0 ${SPACING[100]}px;
`;

export const LoaderContainer = styled.div`
    display: inline-flex;
`;

export interface SingleValueElementProps extends Disableable {
    focused?: boolean;
    size?: SizeType;
}

const getInputToken = getComponentToken(Component.Input);

export const SingleValueElement = styled.div<SingleValueElementProps>`
    max-width: calc(100% - ${getHorizontalInputPadding}px);
    position: absolute;
    top: calc(50% - 1px);
    transform: translateY(-50%);
    ${getInputTextPresetCss}
    color: ${(props) => getInputToken(Decision.Color, { state: props.disabled ? 'disabled' : undefined })};
    ${ELLIPSIS}
`;

interface ValueContainerElementProps {
    leftDetail?: React.ReactNode;
    rightDetail?: React.ReactNode;
    hasTags?: boolean;
    size?: SizeType;
    compact?: boolean;
}

export const ValueContainerElement = styled.div<ValueContainerElementProps>`
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    padding: 5px ${SPACING[200]}px;
    ${(props) => (props.leftDetail || props.size === 'small') && `padding-left: ${SPACING[100]}px;`}
    ${(props) => (props.rightDetail || props.size === 'small') && `padding-right: ${SPACING[100]}px;`}
    box-sizing: border-box;
    min-width: 0;
    margin-top: 1px;
    margin-bottom: 1px;

    & > * {
        margin-top: 1px;
        margin-bottom: 1px;

        &:not(:last-child) {
            margin-right: ${SPACING[50]}px;
        }
    }

    ${(props) =>
        props.size === 'small' &&
        css`
            padding-top: ${props.hasTags ? 1 : 2}px;
            padding-bottom: ${props.hasTags ? 1 : 3}px;
        `}

    ${(props) =>
        props.size === 'large' &&
        css`
            padding-top: 9px;
            padding-bottom: 9px;
        `}

    ${(props) =>
        props.compact &&
        css`
            height: 26px;
            overflow-y: hidden;
        `}
`;

export const SearchContainerElement = styled.div`
    padding: ${SPACING[100]}px ${SPACING[200]}px ${SPACING[100]}px 0;
`;
